<!--
 * @Descripttion:
 * @version:
 * @Author: loong
 * @Date: 2022-07-01 10:48:29
 * @LastEditors: loong
 * @LastEditTime: 2022-10-13 19:16:12
-->
<template>
  <div class="scheme position-relative" id="schemeBoxFixed">
    <template v-if="SolutionsLists.length>0">
      <div :class="solution_rollover_status==1?'scheme-body position-fixed':'scheme-body position-absolute'"
           :style="{ top: solution_rollover_status_STYLE_TOP, bottom: solution_rollover_status_STYLE_BOTTOM,backgroundImage:'url('+SolutionsLists[heighLight].blackground+')' }">
        <div class="solutionTitle">解决方案</div>
        <div class="solutiondesc">面向行业用户需求，基于数据引擎、卫星通信，提供成熟可复制的解决方案。</div>

        <div class="swiperSolution">

          <swiper :options="swiperOption" ref="mySwiper">
            <swiper-slide class="swiperSolution-carousel" v-for="(item,i) in SolutionsLists" :key="i">
              <div class="carouselsolutionTitle" :style="{color:item.themeColor}">{{ item.solutionName }}</div>
              <div class="carouselsolutiondesc">{{ item.content }}</div>
              <div class="carouselsolutionTOdesc" @click="todeail(item.id)"
                   :style="{color:item.themeColor,borderColor:item.themeColor}">查看详情
              </div>
            </swiper-slide>


            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </div>
      <div class="position-relative">
        <div class="scheme-container">
          <div
              style="display: flex;justify-content: flex-end !important;flex-wrap: wrap;margin-right: -15px;margin-left: -15px; ">
            <div style="flex: 0 0 50%;max-width: 50%;">
              <div class="soulutionsCtrlSwiper" v-for="(item,i) in SolutionsLists" :key="i"
                   :id="SolutionsLists.length==(i+1)?'schemeBoxBottom':''">
                <img :src="item.thumbnail" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

  </div>
</template>
<script>
import 'swiper/dist/css/swiper.css'
import {swiper, swiperSlide} from 'vue-awesome-swiper'

export default {
  name: "scheme",
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      SolutionsLists: [],
      showSolution: require("../assets/image/Solution-1.png"),
      heighLight: 0,
      solution_rollover_status: 0,
      offsetTop: 0,
      offsetBottom: 0,
      swiperOption: {
        direction: 'vertical',
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        autoplay: false,
        autoHeight: true,
        height: window.innerHeight,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          // type: 'fraction',
        },
      }, //垂直轮播数据
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    },
    solution_rollover_status_STYLE_TOP() {
      switch (this.solution_rollover_status) {
        case 0: {
          return "auto";
        }
        case 1: {
          return "0";
        }
        case 2: {
          return "auto";
        }

      }
    },
    solution_rollover_status_STYLE_BOTTOM() {
      switch (this.solution_rollover_status) {
        case 0: {
          return "auto";
        }
        case 1: {
          return "auto";
        }
        case 2: {
          return "0px";
        }

      }
    },
  },
  mounted() {
    // 解決方案数据板块接入
    this.$http.post(this.$const.SellerCenter.solutionCategory, "")
        .then((res) => {
          if (res.code == 200) {
            this.SolutionsLists = res.data;
            this.offsetBottom = document.querySelector('#schemeBoxBottom').offsetTop + document.querySelector('#schemeBoxFixed').offsetTop;
          } else {
            // this.$message.error(this.$PubText.getInfoFail);
          }
        })
        .catch((error) => {
          // this.$message.error(this.$PubText.InterfaceFail);
        });
    this.$nextTick(function () {
      window.addEventListener("scroll", this.scrollHandleStart, true); // 监听 监听元素是否进入/移出可视区域
      this.offsetTop = document.querySelector('#schemeBoxFixed').offsetTop;
    })
  },
  beforeDestroy() {
    window.removeEventListener('scroll',this.scrollHandleStart,true)
  },
  methods: {
    todeail(id) {
      this.$router.push({
        name: "solutionDeail",
        params: {
          solutionPlateID: id,
        }
      });
    },
    scrollHandleStart() {
      this.offsetTop = document.querySelector('#schemeBoxFixed').offsetTop;
      this.offsetBottom = document.querySelector('#schemeBoxBottom').offsetTop + document.querySelector('#schemeBoxFixed').offsetTop;
      // 控制多会出入解决方案
      if (document.documentElement.scrollTop < this.offsetBottom && document.documentElement.scrollTop > this.offsetTop) {
        this.solution_rollover_status = 1;
      } else if (document.documentElement.scrollTop < this.offsetTop) {
        this.solution_rollover_status = 0;
      } else if (document.documentElement.scrollTop > this.offsetBottom) {
        this.solution_rollover_status = 2;
      }

      var clientHeight = document.documentElement.clientHeight || document.body.clientHeight;

      this.SolutionsLists.forEach((item, i) => {
        if (this.offsetTop + (clientHeight * i) > document.documentElement.scrollTop - clientHeight * .8 && this.offsetTop + (clientHeight * (i - 1)) < document.documentElement.scrollTop - clientHeight * .8) {
          this.heighLight = i;
          this.$refs.mySwiper.swiper.activeIndex = i;
        }
      })
    }
  },
};
</script>
<style lang='scss' scoped>
.scheme {
  background-color: #f8f9fd;

}

.position-relative {
  position: relative !important;
  pointer-events: none;
  overflow: hidden;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.scheme-body {
  transition: background-image 0.5s ease-in-out 0s;
  height: 100vh;
  // background-image: url(https://images.modao.cc/images/images-2021/website-construction/homepage/section-bg-2.png);
  background-size: auto 100%;
  background-repeat: no-repeat;
  background-origin: content-box;
  background-position: 50px top;
  width: 100%;
}

@media (min-width: 1600px) {
  .scheme-container {
    width: 1500px;
    margin: 0 auto;

  }
}

@media (max-width: 1600px) {
  .scheme-container {
    width: 1200px;
    margin: 0 auto;
  }
}

.soulutionsCtrlSwiper {
  height: 100vh;
  align-items: center !important;
  display: flex;
}

.soulutionsCtrlSwiper img {
  width: 100%;
}

.solutionTitle {
  font-size: 2.1vw;
  font-family: AlibabaPuHuiTiM;
  color: #0C0E39;
  line-height: 55px;
  width: 35%;
  padding: 5% 3% 0 12%;
  color: #2469F1;
}

.solutiondesc {
  font-size: 1.2vw;
  font-family: AlibabaPuHuiTiR;
  color: #0C0E39;
  line-height: 30px;
  padding: 1% 2% 0 12%;
  width: 35%;
}

.carouselsolutionTitle {
  font-size: 1.7vw;
  font-family: AlibabaPuHuiTiB;
  color: #007AFF;
  line-height: 2vw;
  padding: 10% 3% 0 10%;
}

.carouselsolutiondesc {
  font-size: 1vw;
  font-family: AlibabaPuHuiTiR;
  color: #333333;
  line-height: 1.8vw;
  padding: 1% 3% 0 10%;
}

.carouselsolutionTOdesc {
  font-size: 1vw;
  font-family: AlibabaPuHuiTiR;
  color: #333333;
  line-height: 2.2vw;
  margin: 3% 3% 0 69%;
  height: 2.2vw;
  border: 1px solid #ccc;
  text-align: center;
  width: 120px;
  cursor: pointer;
}

.swiperSolution {
  padding: 1% 3% 0 8.5%;
  width: 40%;
  position: relative;
}

.swiper-container-vertical > .swiper-pagination-bullets {
  left: 1%;
  top: 19.5vh;
}

::v-deep .swiper-pagination-bullet-active {
  background-color: #2469F1;
  opacity: 1;
  height: 14px;
  border-radius: 5px;
}
</style>
